
export const getUrlParams = ()=> {
    const url = window.location.href;
    const queryStr = url.split('?')[1]?.split('#')[0] || '';
    const params = new URLSearchParams(queryStr);
    return params;
}

export const storage = {
    set(key, value) {
        try {
            const serialized = JSON.stringify(value);
            localStorage.setItem(key, serialized);
        } catch (error) {
            console.error('localStorage set error:', error);
        }
    },

    get(key) {
        try {
            const raw = localStorage.getItem(key);
            return raw === null ? undefined : JSON.parse(raw);
        } catch (error) {
            console.error('localStorage get error:', error);
            return undefined;
        }
    },

    remove(key) {
        localStorage.removeItem(key);
    }
};

export const isPositiveNumber= str => {
    // 先排除 null, undefined, 空字符串
    if (str == null || str === '') {
        return false;
    }

    const num = parseFloat(str);

    // 检查是否为有效数字 且 大于 0
    return isFinite(num) && num > 0;
}